var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceTypeMacos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1209_6024)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 1.51074,
    width: 60,
    height: 60,
    rx: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1209_6024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0316 15.0034C38.0831 15.1709 38.1153 15.3191 38.1282 15.4478C38.141 15.5767 38.1475 15.7055 38.1475 15.8343C38.1475 16.6587 37.9543 17.5605 37.5678 18.5394C37.1814 19.5185 36.5695 20.4266 35.7322 21.2639C35.0108 21.9724 34.2959 22.4491 33.5874 22.6938C33.1365 22.8355 32.4538 22.945 31.5392 23.0223C31.5649 21.0643 32.0738 19.3703 33.0657 17.9404C34.0704 16.5106 35.7257 15.5316 38.0316 15.0034M25.8584 22.6165C26.8245 22.6165 27.9903 22.8162 29.3558 23.2155C30.7341 23.6148 31.6487 23.8145 32.0996 23.8145C32.6792 23.8145 33.626 23.5891 34.94 23.1382C36.2539 22.6874 37.3939 22.4619 38.36 22.4619C39.9445 22.4619 41.355 22.887 42.5917 23.7372C43.2873 24.2267 43.9764 24.8901 44.6592 25.7274C43.6286 26.6034 42.8751 27.3827 42.3985 28.0654C41.5354 29.3021 41.1038 30.6676 41.1038 32.1618C41.1038 33.7978 41.5611 35.2728 42.4757 36.5867C43.3903 37.9006 44.4337 38.7315 45.606 39.0793C45.1165 40.6637 44.3049 42.319 43.1714 44.0452C41.4581 46.6344 39.7577 47.929 38.0702 47.929C37.4003 47.929 36.4729 47.7165 35.2878 47.2914C34.1155 46.8663 33.1236 46.6537 32.3121 46.6537C31.5005 46.6537 30.5537 46.8727 29.4717 47.3107C28.4025 47.7615 27.533 47.987 26.8632 47.987C24.8407 47.987 22.8569 46.2737 20.9118 42.8472C18.9667 39.4593 17.9941 36.1358 17.9941 32.8768C17.9941 29.8496 18.7348 27.3827 20.2162 25.4762C21.7105 23.5698 23.5912 22.6165 25.8584 22.6165Z",
    stroke: "#4739E7",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 2.01074,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "#4739E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1209_6024",
    x: 0.75,
    y: 0.510742,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1209_6024"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0.878431 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1209_6024"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1209_6024",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1209_6024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.229,
    height: 36,
    fill: "white",
    transform: "translate(16.6355 13.5107)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceTypeMacos);
export default __webpack_public_path__ + "static/media/device-type-macos.da021b77720d39333277ffe1ea7705d6.svg";
export { ForwardRef as ReactComponent };